import { render, staticRenderFns } from "./HirebotPrice.vue?vue&type=template&id=5a4bb798&scoped=true&"
import script from "./HirebotPrice.vue?vue&type=script&lang=js&"
export * from "./HirebotPrice.vue?vue&type=script&lang=js&"
import style0 from "./HirebotPrice.vue?vue&type=style&index=0&id=5a4bb798&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4bb798",
  null
  
)

export default component.exports